/**
 * Adapt branches to options
 * Sort alphabetically by branchName
 * @param {Array} branches
 * @param {string|number} currentBranch - ID of the currently selected branch
 * @returns {Array}
 */
const adaptBranchesToOptions = (branches = [], currentBranch = null) => {
  const adapted = branches.map(({ branchId, branchName, isOwner }) => ({
    id: branchId,
    label: branchName,
    isOwner: currentBranch ? branchId === currentBranch : isOwner
  }));

  // Sort alphabetically by branchName (label)
  adapted.sort((a, b) => a.label.localeCompare(b.label));

  return adapted;
};

export default adaptBranchesToOptions;
